module.exports = __webpack_public_path__ + "img/home4.985618ca.svg";